/**
 * Whole-number percentages that add up to exactly 100 (largest remainder
 * method), so a legend never reads 99% or 101%. Zero total gives zeros.
 */
export function roundShares(values: readonly number[]): number[] {
  const total = values.reduce((s, v) => s + Math.max(0, v), 0);
  if (total <= 0) return values.map(() => 0);
  const exact = values.map((v) => (Math.max(0, v) / total) * 100);
  const floored = exact.map(Math.floor);
  let left = 100 - floored.reduce((s, v) => s + v, 0);
  const order = exact
    .map((v, i) => ({ i, frac: v - Math.floor(v) }))
    .sort((a, b) => b.frac - a.frac || a.i - b.i);
  for (const { i } of order) {
    if (left <= 0) break;
    floored[i]! += 1;
    left -= 1;
  }
  return floored;
}
